// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

function readAllTrackingEvents(trackingNumber: string): any {
    let baseUrl = config.TRACKING_EVENTS_URL;
    console.log('baseUrl', `${baseUrl}/${trackingNumber}`);
    return api.get(`${baseUrl}/${trackingNumber}`, {});
}

export {
    readAllTrackingEvents,
};
